import axios, { AxiosRequestConfig } from 'axios'

import { useAppStore } from '@/store/app'
import config from '../config'
import { setupAutoUpdateIamToken } from './setupIamToken'
import { setupAutoUpdateToken } from './setupToken'

export const getHeader = () => {
  return {
    channel: 'APP',
    source: 'WEB_USER',
    version: '2021-07-28',
  }
}

export const requests = (host?: string) => {
  const baseUrl = host || config.restApiUrl
  const axiosInstance = axios.create({
    baseURL: baseUrl,
    headers: getHeader(),
  })

  axiosInstance.interceptors.request.use(
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    async (requestConfig: AxiosRequestConfig) => {
      try {
        const store = useAppStore()
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        requestConfig.headers['token-id'] = store.tokenId
      } catch (e) {
        console.error(e)
      }
      return requestConfig
    }
  )
  setupAutoUpdateToken(axiosInstance)
  return axiosInstance
}

export const requestsV2 = (host?: string) => {
  const baseUrl = host || config.restApiUrl
  const axiosInstance = axios.create({
    baseURL: baseUrl,
    headers: getHeader(),
  })

  axiosInstance.interceptors.request.use(
    async (requestConfig: AxiosRequestConfig) => {
      try {
        const store = useAppStore()
        requestConfig.headers['token-id'] = store.tokenId
        requestConfig.headers['Authorization'] = `Bearer ${store.iamToken}`
      } catch (e) {
        console.error(e)
      }
      return requestConfig
    }
  )
  setupAutoUpdateIamToken(axiosInstance)
  return axiosInstance
}
